import {
  ILeaveActionCreator,
  ILeaveListState,
  ILeaveActionTypes,
} from "models/ILeaveState";

const initialState: any = {
  leaves: [],
  leavesInfo: {},
  adminLeavesInfo: {},
  total_pages: 0,
  lop_leaves: [],
  admin_leaves: [],
  leave_approval_types: [],
  employees: [],
};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case ILeaveActionTypes.FETCH_LEAVE_LIST_FAILURE:
      return {
        ...state,
        leaves: [],
      };
    case ILeaveActionTypes.FETCH_LEAVE_LIST_SUCCESS:
      return {
        ...state,
        leavesInfo: payload?.data,
        leaves: [...payload?.data?.leave_applications],
        total_pages: payload?.data?.total_pages || 0,
      };

    case ILeaveActionTypes.FETCH_LOP_LIST_FAILURE:
      return {
        lop_leaves: [],
      };
    case ILeaveActionTypes.FETCH_LOP_LIST_SUCCESS:
      return {
        ...state,
        lop_leaves: [...payload?.data],
      };
    case ILeaveActionTypes.FETCH_LEAVE_ADMIN_LIST_FAILURE:
      return {
        admin_leaves: [],
      };
    case ILeaveActionTypes.FETCH_LEAVE_ADMIN_LIST_SUCCESS:
      return {
        ...state,
        admin_leaves: payload?.data?.leave_applications || [],
        adminLeavesInfo: payload?.data,
      };
    case ILeaveActionTypes.FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_REQUEST:
      return {
        ...state,
        leave_approval_types: [],
      };
    case ILeaveActionTypes.FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_SUCCESS:
      return {
        ...state,
        leave_approval_types: [...payload.data],
      };
    case ILeaveActionTypes.FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_REQUEST:
      return {
        ...state,
        employees: [],
      };
    case ILeaveActionTypes.FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_SUCCESS:
      return {
        ...state,
        employees: [...payload.data.mappings],
      };

    default:
      return state;
  }
};

export default reducer;
